// Preview↔Production Pusher channel isolation (2026-02-17).
//
// Both environments share a single Pusher app (same PUSHER_KEY), so
// un-suffixed channels are cluster-wide → prod broadcasts leaked
// into preview clients and vice-versa (real incident: "order in
// processing" toast appeared on preview whenever a prod order was
// processed). Fix: suffix every channel name with an env tag that
// matches whatever the backend derived from its own env vars.
//
// Derivation must match `pusher_god_mode._detect_app_env()` on the
// backend so the two sides agree without a network round-trip on
// every page load.

const url = String(process.env.REACT_APP_BACKEND_URL || "").toLowerCase();

let detected;
const explicit = String(process.env.REACT_APP_APP_ENV || "").trim().toLowerCase();
if (explicit) {
  detected = explicit;
} else if (url.includes("preview") || url.includes("localhost")) {
  detected = "preview";
} else {
  detected = "production";
}

export const APP_ENV = detected;

/**
 * Return the environment-suffixed channel name.
 * Presence and private prefixes remain intact — the suffix goes at
 * the end so Pusher's auth routing continues to work.
 */
export function envChannel(baseChannel) {
  return `${baseChannel}--${APP_ENV}`;
}
